<!-- 公共头部 -->
<template>
  <div class="header" ref="head">
    <div
      class="headerChange"
      id="animate_active"
      @mouseenter="enter"
      @mouseleave="leave"
    >
      <div class="header_center">
        <img :src="img1before" alt class="logo" @click="handleToHome" />
        <ul>
          <li
            :class="activeIndex == index ? 'activeItem' : 'beforeItem'"
            v-for="(item, index) in headerList"
            :key="index"
            @mouseenter="selected(index)"
            @click="handleChange(index)"
            refs="li"
          >
            {{ item.name }}
          </li>
        </ul>
        <div class="header_right">
          <span class="division"></span>
          <img :src="img2before" class="sou" style="cursor: pointer" alt />
          <img
            :src="img3before"
            class="dao"
            style="cursor: pointer"
            @click="showAll"
            alt
          />
        </div>
      </div>
      <div class="nav" @mouseenter="navShow">
        <!-- 解决方案 -->
        <ul
          class="nav_ul"
          v-show="activeIndex == 0 ? true : false"
          @mouseenter="navShow(activeIndex)"
          @mouseleave="navNone(activeIndex)"
          ref="navItem0"
        >
          <router-link
            tag="li"
            class="nav_li"
            :to="item.link"
            v-for="(item, index) in jieList"
            :key="index"
            @click.native="flushCom"
          >
            <span>{{ item.name }}</span>
          </router-link>
        </ul>
        <!-- 产品中心 -->
        <ul
          class="nav_ul"
          v-show="activeIndex == 1 ? true : false"
          @mouseenter="navShow(activeIndex)"
          @mouseleave="navNone(activeIndex)"
          ref="navItem1"
        >
          <li
            class="nav_li"
            :to="item.link"
            v-for="(item, index) in chanList"
            :key="index"
          >
            <router-link
              tag="div"
              v-for="(it1, index) in item.title"
              :key="index"
              :to="it1.link"
              @click.native="flushCom"
            >
              <span class="first_span">{{ it1.name }}</span>
            </router-link>
            <router-link
              tag="div"
              :to="it.link"
              v-for="(it, index) in item.detail"
              :key="index"
              @click.native="flushCom"
            >
              <span class="sec_span">{{ it.name }}</span>
            </router-link>
          </li>
        </ul>
        <!-- 咨询服务 -->
        <ul
          class="nav_ul"
          v-show="activeIndex == 2 ? true : false"
          @mouseenter="navShow(activeIndex)"
          @mouseleave="navNone(activeIndex)"
          ref="navItem2"
        >
          <li
            class="nav_li"
            :to="item.link"
            v-for="(item, index) in ziList"
            :key="index"
          >
            <router-link
              tag="div"
              v-for="(it1, index) in item.title"
              :key="index"
              :to="it1.link"
              @click.native="flushCom"
            >
              <span class="first_span">{{ it1.name }}</span>
            </router-link>
            <router-link
              tag="div"
              :to="it.link"
              v-for="(it, index) in item.detail"
              :key="index"
              @click.native="flushCom"
            >
              <span class="sec_span">{{ it.name }}</span>
            </router-link>
          </li>
        </ul>
        <!-- 专长 -->
        <ul
          class="nav_ul"
          v-show="activeIndex == 3 ? true : false"
          @mouseenter="navShow(activeIndex)"
          @mouseleave="navNone(activeIndex)"
          ref="navItem3"
        >
          <li
            tag="li"
            class="nav_li"
            v-for="(item, index) in zhuanList"
            @click="handleZhuan(index)"
            :key="index"
          >
            {{ item.name }}
          </li>
        </ul>
        <!-- 了解我们 -->
        <ul
          class="nav_ul"
          v-show="activeIndex == 4 ? true : false"
          @mouseenter="navShow(activeIndex)"
          @mouseleave="navNone(activeIndex)"
          ref="navItem4"
        >
          <li
            tag="li"
            class="nav_li"
            v-for="(item, index) in liaoList"
            :key="index"
            @click="handleLiao(index)"
          >
            {{ item.name }}
          </li>
        </ul>
        <!-- 加入我们 -->
        <ul
          class="nav_ul"
          v-show="activeIndex == 5 ? true : false"
          @mouseenter="navShow(activeIndex)"
          @mouseleave="navNone(activeIndex)"
          ref="navItem5"
        >
          <router-link
            tag="li"
            class="nav_li"
            :to="item.link"
            v-for="(item, index) in jiaList"
            :key="index"
            >{{ item.name }}</router-link
          >
        </ul>
      </div>
    </div>

    <transition name="modal">
      <div class="modal" v-if="modalFlag" @mousewheel.prevent>
        <div class="modal_center">
          <div class="modal_top">
            <img src="@assets/img/logow.png" @click="handleToHome" alt />
            <span
              class="iconfont cha"
              @click="handleClose"
              @mouseenter="zhuan"
              @mouseleave="zhuan"
              :class="{ go: rotate, aa: !rotate }"
              >&#xe618;</span
            >
          </div>
          <div style="display: flex; justify-content: space-between">
            <ul class>
              <!-- <span v-for="(item,index) in headerList" :key="index">{{item.name}}</span> -->
              <span @click="handleJieSecond" class="title">解决方案</span>
              <router-link
                tag="li"
                class="nav_li"
                :to="item.link"
                v-for="(item, index) in jieList"
                :key="index"
                @click.native="flushCom"
              >
                <span>{{ item.name }}</span>
              </router-link>
            </ul>
            <ul class>
              <!-- <span v-for="(item,index) in headerList" :key="index">{{item.name}}</span> -->
              <span @click="handleChanSecond">产品中心</span>
              <li class="nav_li" v-for="(ite, index) in chanList" :key="index">
                <router-link
                  tag="div"
                  v-for="(it1, index) in ite.title"
                  :key="index"
                  :to="it1.link"
                  @click.native="flushCom"
                >
                  <span>{{ it1.name }}</span>
                </router-link>
                <router-link
                  tag="div"
                  :to="it.link"
                  v-for="(it, index) in ite.detail"
                  :key="index"
                  style="display: block; text-indent: 10px"
                  @click.native="flushCom"
                >
                  &nbsp;&nbsp;
                  <span>{{ it.name }}</span>
                </router-link>
              </li>
            </ul>
            <ul class>
              <!-- <span v-for="(item,index) in headerList" :key="index">{{item.name}}</span> -->
              <span @click="handleZiSecond">咨询服务</span>
              <li
                class="nav_li"
                :to="ite2.link"
                v-for="(ite2, index) in ziList"
                :key="index"
              >
                <router-link
                  tag="div"
                  v-for="(it1, index) in ite2.title"
                  :key="index"
                  :to="it1.link"
                  @click.native="flushCom"
                >
                  <span>{{ it1.name }}</span>
                </router-link>
                <router-link
                  tag="div"
                  :to="it.link"
                  v-for="(it, index) in ite2.detail"
                  :key="index"
                  style="display: block; text-indent: 10px"
                  @click.native="flushCom"
                >
                  &nbsp;&nbsp;
                  <span>{{ it.name }}</span>
                </router-link>
              </li>
            </ul>
            <ul class>
              <span @click="handleZhuanSecond">专长</span>
              <li
                v-for="(item, index) in zhuanList"
                :key="index"
                @click="handleZhuan(index)"
              >
                <span>{{ item.name }}</span>
              </li>
            </ul>
            <ul class>
              <span @click="handleLiaoSecond">了解我们</span>
              <li
                v-for="(item, index) in liaoList"
                :key="index"
                @click="handleLiao(index)"
              >
                <span>{{ item.name }}</span>
              </li>
            </ul>
            <!-- <ul class>
              <span>加入我们</span>
              <li v-for="(ite,index) in jiaList" :key="index">
                <span>{{ite.name}}</span>
              </li>
            </ul>-->
          </div>
        </div>
      </div>
    </transition>

    <!-- <div v-show="backToTop" @click="backtop" class="up"><i class="iconfont">&#xe61f;</i></div> -->
    <div v-show="btnFlag" @click="backtop" class="up">
      <i class="iconfont">&#xe61f;</i>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  name: "Header",
  data() {
    return {
      img1before: require("@assets/img/logob.png"),
      img2before: require("@assets/img/soub.png"),
      img3before: require("@assets/img/daob.png"),
      activeIndex: -1,
      modalFlag: false,
      rotate: false, //控制互转效果
      activeNav: -1, //二级侧边导航点亮
      headerList: [
        { name: "解决方案", url: "solution" },
        { name: "产品中心", url: "productCenter" },
        { name: "咨询服务", url: "consulting" },
        { name: "专长", url: "expertise" },
        { name: "了解我们", url: "knowus" },
        // { name: "加入我们", url: "home" },
      ],
      jieList: [
        { name: "自动化", link: "automation" },
        { name: "物联", link: "iot" },
        { name: "能源", link: "energy" },
        { name: "环境", link: "environmental" },
      ],
      chanList: [
        {
          title: [{ name: "工业无线", link: "industrialWir" }],
          detail: [
            { name: "无线网络", link: "industrialWir" },
            { name: "无线通讯", link: "industrialWir" },
            { name: "无线位置", link: "industrialWir" },
            { name: "无线分析", link: "industrialWir" },
          ],
        },
        {
          title: [{ name: "工业软件", link: "industrialSoft" }],
          detail: [
            { name: "能源管理软件", link: "industrialSoft" },
            { name: "大数据平台", link: "industrialSoft" },
            { name: "GIS地图信息平台", link: "industrialSoft" },
          ],
        },
        {
          title: [{ name: "仪器仪表", link: "measuring" }],
          detail: [
            { name: "流体仪表", link: "measuring" },
            { name: "电力仪表", link: "measuring" },
            { name: "压力仪表", link: "measuring" },
            { name: "温度仪表", link: "measuring" },
            { name: "液位仪表", link: "measuring" },
          ],
        },
      ],
      ziList: [
        {
          title: [{ name: "咨询", link: "consultSer" }],
          detail: [
            { name: "智能工厂咨询服务", link: "intellFactory" },
            { name: "工业物联园区咨询服务", link: "iotPark" },
          ],
        },
        {
          title: [{ name: "服务", link: "servicing" }],
          detail: [
            { name: "设备安装与运维服务", link: "install" },
            { name: "数据分析与校准服务", link: "dataAnalysis" },
            // { name: "能源与能效诊断服务", link: "" },
          ],
        },
      ],
      zhuanList: [
        { name: "综合介绍", link: "" },
        { name: "能源", link: "" },
        { name: "流体计量", link: "" },
        { name: "数据分析与校准服务", link: "" },
      ],
      liaoList: [
        { name: "企业概述", link: "" },
        { name: "企业文化", link: "" },
        { name: "荣誉资质", link: "" },
        { name: "新闻报告", link: "" },
        { name: "合作伙伴", link: "" },
      ],
      jiaList: [
        { name: "社会招聘", link: "" },
        { name: "校园招聘", link: "" },
      ],
      navFlag: true,
      backToTop: false,
      scrollTop: 0,
      btnFlag: false,
    };
  },
  components: {},
  mounted() {
    window.addEventListener("scroll", this.scrollToTop, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    handleToHome() {
      //点击图片跳转到首页
      this.modalFlag = false;
      this.$router.push("/");
      this.reload();
    },
    enter: function () {
      this.activeIndex = -1;
    },
    leave: function () {
      this.activeIndex = -1;
    },
    selected(index) {
      this.activeIndex = index;
    },
    noselected() {
      this.activeIndex = -1;
    },
    navShow() {
      // console.log(index);
      // this.navFlag=true;
    },
    navNone() {
      // console.log(index);
    },
    flushCom() {
      // this.$router.go(0);
      this.reload();
    },
    //跳转头部相应页面
    handleChange(index) {
      this.$router.push(this.headerList[index].url);
      this.reload();
      if (index == 3) {
        sessionStorage.setItem("expertise", 0);
      }
      if (index == 4) {
        sessionStorage.setItem("knowus", 0);
      }
    },
    // 点击头部-专长
    handleZhuan(index) {
      // console.log(index)
      // this.$nextTick(() => {
      sessionStorage.setItem("expertise", index);
      this.$router.push({ name: "Expertise", params: { tab: index } });
      this.reload();
      // window.location.reload();
      // });
    },
    // 点击头部-了解我们
    handleLiao(index) {
      sessionStorage.setItem("knowus", index);
      this.$router.push({ name: "Knowus", params: { tab: index } });
      //  window.location.reload();
      this.reload();
    },
    showAll() {
      //打开弹窗
      //点击右上角三条横杠
      //   console.log(123)
      //   this.$observer.$emit("handleModal",{flag:true})
      this.modalFlag = true;
    },
    handleClose() {
      //关闭弹窗
      // this.$observer.$emit("handleModal",false)
      this.modalFlag = false;
    },
    zhuan() {
      //旋转模态框叉号
      this.rotate = !this.rotate;
    },
    //跳往解决方案二级页面
    handleJieSecond() {
      this.$router.push("/solution");
      this.reload();
    },
    //跳往产品中心二级页面
    handleChanSecond() {
      this.$router.push("/productCenter");
      this.reload();
    },
    //跳往咨询服务二级页面
    handleZiSecond() {
      this.$router.push("/consulting");
      this.reload();
    },
    //跳往专长页面
    handleZhuanSecond() {
      this.$router.push("/expertise");
      //  this.modalFlag = false;
      this.reload();
    },
    //跳往了解我们页面
    handleLiaoSecond() {
      this.$router.push("/knowus");
      // this.modalFlag=false
      this.reload();
    },
    // 显示回到顶部按钮
    // scrollToTop() {
    //   let scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;
    //   let browserHeight = window.outerHeight;
    //   if (scrollTop > browserHeight) {
    //     this.backToTop = true;
    //   } else {
    //     this.backToTop = true;
    //   }
    // },
    //跳转到页面顶部
    backtop() {
      let back = setInterval(() => {
        if (document.body.scrollTop || document.documentElement.scrollTop) {
          document.body.scrollTop -= 100;
          document.documentElement.scrollTop -= 100;
        } else {
          clearInterval(back);
        }
      });
    },
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 60) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    // backtop() {
    //   // this.$refs.head.scrollIntoView();
    //   // var timer = setInterval(function () {
    //   //   let osTop =
    //   //     document.documentElement.scrollTop || document.body.scrollTop;
    //   //   let ispeed = Math.floor(-osTop / 5);
    //   //   document.documentElement.scrollTop = document.body.scrollTop =
    //   //     osTop + ispeed;
    //   //   this.isTop = true;
    //   //   if (osTop === 0) {
    //   //     clearInterval(timer);
    //   //   }
    //   // }, 30);
    //   let back = setInterval(() => {
    //     if (document.body.scrollTop || document.documentElement.scrollTop) {
    //       document.body.scrollTop -= 100;
    //       document.documentElement.scrollTop -= 100;
    //     } else {
    //       clearInterval(back);
    //     }
    //   });
    // },
  },
};
</script>

<style lang='scss' scoped>
#animate_active {
  transition: all 0.3s ease-in-out; //这是滑入划出的动画
}
.nav_ul {
  transition: all 0.6s ease-in-out; //这是滑入划出的动画
}
.headerChange {
  background: white;
  width: 100%;
  height: 100px;
  border-bottom: 1px solid white;
  border-bottom-color: rgba(255, 255, 255, 0.2);
  position: relative;
  top: 0;
  .header_center {
    width: 95%;
    height: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      cursor: pointer;
      width: 371px;
      height: 55px;
    }
    ul {
      height: 100px;
      width: 40%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      li {
        box-sizing: border-box;
        height: 100%;
        line-height: 100px;
        cursor: pointer;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #333333;
        float: left;
      }
    }
    .header_right {
      width: 8%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .division {
        display: inline-block;
        width: 2px;
        height: 36px;
        background: rgba(228, 228, 228, 1);
        //       // margin-top: 30px;
        //       // margin-right: 46px;
      }
      img {
        width: 20px;
      }
      .sou {
        //       // margin-right: 44px;
        //       // margin-top: 37px;
      }
      .dao {
        //       // margin-top: 38px;
      }
    }
  }
}
.activeItem {
  color: rgba(220, 186, 121, 1) !important;
  border-bottom: 3px solid rgba(220, 186, 121, 1);
  transition: border-bottom 0.2s ease;
}
.nav {
  width: 100%;
  // background: rgba(0, 0, 0, 1);
  opacity: 0.8;
  position: absolute;
  top: 100px;
  z-index: 1000 !important;
  .nav_ul {
    background: rgba(0, 0, 0, 1);
    padding: 30px 220px;
    display: flex;
    justify-content: center;
    .nav_li {
      cursor: pointer;
      list-style: disc;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      margin-right: 220px;
      &:nth-last-child(1) {
        margin-right: 0px;
      }
    }
    span {
      display: block;
      margin-top: 15px;
      margin-bottom: 10px;
      cursor: pointer;
    }
  }
}
.first_span {
  font-size: 16px !important;
}
.sec_span {
  text-indent: 16px;
}
.aa {
  transition: all 0.5s;
}
.go {
  transform: rotate(180deg);
  transition: all 0.5s;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
//modal进入和离开的动画时间段
.modal-enter-active,
.modal-leave-active {
  transition: all 0.5s ease;
}
.modal {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1000;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.8;
  // padding: 15px 180px 0px;
  padding-top: 7px;
  .modal_center {
    width: 80%;
    height: 100%;
    margin: 0 auto;
    padding: 15px 0px;
  }
  .modal_top {
    margin-bottom: 60px;
    img {
      width: 371px;
      height: 55px;
      cursor: pointer;
    }
  }
  .cha {
    color: white;
    font-size: 30px;
    float: right;
    cursor: pointer;
  }
  span {
    font-size: 18px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
  }
  .all {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  li {
    span {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      margin-top: 20px;
      display: inline-block;
      cursor: pointer;
    }
  }
  .title {
    margin-bottom: 10px;
  }
}
.up {
  height: 40px;
  width: 40px;
  background-color: #f2f5f6;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  text-align: center;
  line-height: 40px;
  color: #dcba79;
  position: fixed;
  cursor: pointer;
  right: 50px;
  bottom: 100px;
  border-radius: 5px;
  font-size: 14px;
}
</style>
